// Job security H (research/trade-value-spec.md §5), as a trade-AI signal.
//
// ZenGM ALREADY implements most of H, so this does NOT reimplement it:
//   - Firing / "win before you're fired": genMessage.ts fires the user's GM when owner mood
//     (wins + playoffs + money) drops <= -1 after the grace period.
//   - Contention -> trade strategy: updateStrategies.ts flips teams rebuilding/contending
//     from their roster, which already weights win-now vs. future in sumValues.
//
// The one dimension our design adds that ZenGM's trade AI lacks is coupling win-now
// aggressiveness to JOB PRESSURE: a team underachieving its talent (hot seat) mortgages the
// future harder, while an overachieving/secure team is more patient. We derive that pressure
// from the gap between a team's talent-expected win% and its actual record, and nudge how
// much it values FUTURE assets (draft picks + young players) in a trade.

// Hot-seat signal in [-1, 1]: positive = winning less than its talent implies (pressure to
// win now); negative = overachieving (secure, can be patient). Saturates at a 0.4 win% gap.
export const hotSeatFactor = (expectedWinp: number, actualWinp: number): number =>
	Math.max(-1, Math.min(1, (expectedWinp - actualWinp) / 0.4));

// How hard the win-now bias swings future-asset value (kept modest to layer safely on top
// of ZenGM's existing strategy weighting).
const SWING = 0.2;

/** Multiplier on future-asset value: hot seat < 1 (discount the future), secure > 1. */
export const winNowMultiplier = (hotSeat: number): number =>
	Math.max(1 - SWING, Math.min(1 + SWING, 1 - SWING * hotSeat));
